import React from 'react';
import { PropTypes } from 'prop-types';
import {
    TableRowColumn,
    TableRow,
    Table,
    TableBody,
    TableHeaderColumn,
    TableHeader,
} from 'material-ui/Table';
import './resultsTable.css';
import { formattedNumber } from '../../../../../utils/formatterHelpers';

const ResultsTable = (props) => {
    const {
        annualResults,
        selectedFinancing,
        projectState,
        sgipToggle,
        includeESS,
        obsTerm,
        resiToggle,
        capTerm,
        loanProvider,
    } = props;
    const years = Object.keys(annualResults);

    let rotateSavings = null;
    if (selectedFinancing === 4) {
        rotateSavings = `$${formattedNumber(annualResults[30].cumulativeCashSavings)}`;
    } else if (selectedFinancing === 2 && loanProvider === 'mosaic') {
        rotateSavings = `$${formattedNumber(annualResults[30].cumulativeMosaicSavings)}`;
    } else if (selectedFinancing === 2 && loanProvider === 'custom') {
        rotateSavings = `$${formattedNumber(annualResults[30].cumulativeLoanSavings)}`;
    } else if (selectedFinancing === 3) {
        rotateSavings = `$${formattedNumber(annualResults[30].cumulativeOBSSavings)}`;
    } else if (selectedFinancing === 5) {
        rotateSavings = `$${formattedNumber(annualResults[30].cumulativeCAPSavings)}`;
    }
    let rotateOption = null;
    if (selectedFinancing === 4) {
        rotateOption = 'Cash Purchase';
    } else if (selectedFinancing === 2 && loanProvider === 'mosaic') {
        rotateOption = 'Mosaic ';
    } else if (selectedFinancing === 2 && loanProvider === 'custom') {
        rotateOption = 'Loan ';
    } else if (selectedFinancing === 3) {
        rotateOption = 'Operating Lease ';
    } else if (selectedFinancing === 5) {
        rotateOption = 'Capital Lease ';
    }


    return (
        <div>
            <div className="table">
                <Table>
                    <TableHeader displaySelectAll={false}>
                        <TableRow>
                            <TableHeaderColumn tooltip="System Age"> Year</TableHeaderColumn>
                            <TableHeaderColumn tooltip="Utility Bill After Solar"> Remaining Bill</TableHeaderColumn>
                            <TableHeaderColumn tooltip="Simulated solar production.">
                                Solar Production
                            </TableHeaderColumn>
                            <TableHeaderColumn tooltip="Net Metering Rate per kWh.">
                                Solar Value
                            </TableHeaderColumn>
                            {selectedFinancing === 1 ? (
                                <TableHeaderColumn>PPA Payment</TableHeaderColumn>
                            ) : null}
                            {selectedFinancing > 1 && projectState === 3 ? (
                                <TableHeaderColumn tooltip="Rewnewable Energy Credits">REC Income</TableHeaderColumn>
                            ) : null}
                            {selectedFinancing > 1 && projectState === 2 ? (
                                <TableHeaderColumn tooltip="MA's Solar and Storage incentive. ">SMART</TableHeaderColumn>
                            ) : null}
                            {selectedFinancing > 1 && projectState === 4 ? (
                                <TableHeaderColumn tooltip="NY State Solar Rebate">NYSERDA Rebate</TableHeaderColumn>
                            ) : null}
                            {selectedFinancing > 1 && resiToggle && projectState === 4 ? (
                                <TableHeaderColumn tooltip="NY State Solar Rebate">NY Tax Credit</TableHeaderColumn>
                            ) : null}
                            {selectedFinancing > 1 && projectState === 4 ? (
                                <TableHeaderColumn tooltip="NYC's Property Tax Abatement">Property Tax Abatement</TableHeaderColumn>
                            ) : null}
                            {selectedFinancing === 1 ? (
                                <TableHeaderColumn>Annual Savings</TableHeaderColumn>
                            ) : null}
                            {selectedFinancing === 1 ? (
                                <TableHeaderColumn>PPA Savings</TableHeaderColumn>
                            ) : null}
                            {sgipToggle === true &&
                                projectState === 1 &&
                                selectedFinancing > 1 &&
                                includeESS === true ? (
                                    <TableHeaderColumn tooltip="Self-Generation Incentive Program">SGIP</TableHeaderColumn>
                                ) : null}
                            {sgipToggle === true &&
                                projectState === 1 &&
                                selectedFinancing > 1 &&
                                includeESS === true ? (
                                    <TableHeaderColumn tooltip="Self-Generation Incentive Program - Perfomance Based Incentive">SGIP PBI</TableHeaderColumn>
                                ) : null}

                            {selectedFinancing > 1 && projectState === 2 && resiToggle
                                ? (
                                    <TableHeaderColumn tooltip="MA State Tax Credit">MA Credit</TableHeaderColumn>
                                ) : null}
                            {selectedFinancing === 4
                                || selectedFinancing === 2
                                || selectedFinancing === 3
                                || selectedFinancing === 5
                                ? (
                                    <TableHeaderColumn tooltip="Federal Investment Tax Credit">ITC</TableHeaderColumn>
                                ) : null}
                            {(resiToggle === false &&
                              selectedFinancing === 4)
                              || (resiToggle === false
                              && selectedFinancing === 2)
                              || (resiToggle === false &&
                                selectedFinancing === 5) ? (
                                    <TableHeaderColumn tooltip="Cash Value of Depreciating System at Tax Bracket">MACRS</TableHeaderColumn>
                                ) : null}
                            {selectedFinancing === 4 ? (
                                <TableHeaderColumn tooltip="Turn-Key System Installed Price">Price</TableHeaderColumn>
                            ) : null}
                            {selectedFinancing === 5 ||
                              selectedFinancing === 2 ||
                              selectedFinancing === 3 ? (
                                  <TableHeaderColumn
                                        tooltip="Annual Finance Payments"
                                    >
                                      Payments
                                    </TableHeaderColumn>
                                ) : null}
                            {selectedFinancing === 4
                                || selectedFinancing === 2
                                || selectedFinancing === 3
                                || selectedFinancing === 5
                                ? (
                                    <TableHeaderColumn tooltip="Cumulative Annual Savings">Savings</TableHeaderColumn>
                                ) : null}
                        </TableRow>
                    </TableHeader>
                    <TableBody showRowHover displayRowCheckbox={false}>
                        {years.map(year => (
                            <TableRow key={year} style={{ height: '20px' }}>
                                <TableRowColumn colSpan="1" className="tableRowColumn">
                                    {`Year ${year}`}
                                </TableRowColumn>
                                <TableRowColumn colSpan="1">
                                    {`$ ${formattedNumber(annualResults[year].remainingBill)}`}
                                </TableRowColumn>
                                <TableRowColumn colSpan="1">
                                    {annualResults[year].systemProduction
                                        ? `${formattedNumber(annualResults[year].systemProduction)} kWh`
                                        : '--'}
                                </TableRowColumn>
                                <TableRowColumn colSpan="1">
                                    {annualResults[year].annualSolarSavings > 0
                                        ? `$ ${formattedNumber(annualResults[year].annualSolarSavings)}`
                                        : '--'}
                                </TableRowColumn>
                                {selectedFinancing > 1 && projectState === 3
                                    ? (
                                        <TableRowColumn colSpan="1">
                                            {`$ ${formattedNumber(annualResults[year].recs)}`}
                                        </TableRowColumn>
                                    ) : (
                                        '--'
                                    )}
                                {selectedFinancing > 1 && projectState === 2
                                    ? (
                                        <TableRowColumn colSpan="1">
                                            {annualResults[year].smart > 0
                                                ? `$ ${formattedNumber(annualResults[year].smart)}`
                                                : '--'}
                                        </TableRowColumn>
                                    ) : null}
                                {selectedFinancing > 1 && projectState === 4
                                    ? (
                                        <TableRowColumn colSpan="1">
                                            {annualResults[year].nyserdaRebate > 0
                                                ? `$ ${formattedNumber(annualResults[year].nyserdaRebate)}`
                                                : '--'}
                                        </TableRowColumn>
                                    ) : null}
                                {projectState === 2 && resiToggle
                                    ? (
                                        <TableRowColumn colSpan="1">
                                            {annualResults[year].maStateTaxCredit > 0
                                                ? `$ ${formattedNumber(annualResults[year].maStateTaxCredit)}`
                                                : '--'}
                                        </TableRowColumn>
                                    ) : null}
                                {selectedFinancing > 1 && resiToggle && projectState === 4
                                    ? (
                                        <TableRowColumn colSpan="1">
                                            {annualResults[year].nyResiTaxCredit > 0
                                                ? `$ ${formattedNumber(annualResults[year].nyResiTaxCredit)}`
                                                : '--'}
                                        </TableRowColumn>
                                    ) : null}
                                {(selectedFinancing > 2 && projectState === 4)
                                    ? (
                                        <TableRowColumn colSpan="1">
                                            {annualResults[year].cashNYAbatement > 0
                                                ? `$ ${formattedNumber(annualResults[year].cashNYAbatement)}`
                                                : '--'}
                                        </TableRowColumn>
                                    ) : null}
                                {(selectedFinancing === 2 && projectState === 4)
                                    ? (
                                        <TableRowColumn colSpan="1">
                                            {annualResults[year].mosaicNYAbatement > 0
                                                ? `$ ${formattedNumber(annualResults[year].mosaicNYAbatement)}`
                                                : '--'}
                                        </TableRowColumn>
                                    ) : null}
                                {selectedFinancing === 1 ? (
                                    <TableRowColumn colSpan="1">
                                        {annualResults[year].ppaRate > 0
                                            ? `$ ${formattedNumber(annualResults[year].ppaBill)}`
                                            : '--'}
                                    </TableRowColumn>
                                ) : null}
                                {selectedFinancing === 1 ? (
                                    <TableRowColumn colSpan="1">
                                        {annualResults[year].ppaRate > 0
                                            ? `$ ${formattedNumber(annualResults[year].annualPPASavings)}`
                                            : '--'}
                                    </TableRowColumn>
                                ) : null}
                                {selectedFinancing === 1 ? (
                                    <TableRowColumn colSpan="1">
                                        {annualResults[year].ppaRate > 0
                                            ? `$ ${formattedNumber(annualResults[year].cumulativePPASavings)}`
                                            : '--'}
                                    </TableRowColumn>
                                ) : null}
                                {sgipToggle === true &&
                                    projectState === 1 &&
                                    selectedFinancing > 1 &&
                                    includeESS === true ? (
                                        <TableRowColumn colSpan="1">
                                            {annualResults[year].sgip > 0
                                                ? `$ ${formattedNumber(annualResults[year].sgip)}`
                                                : '--'}
                                        </TableRowColumn>
                                    ) : null}
                                {sgipToggle === true &&
                                    projectState === 1 &&
                                    selectedFinancing > 1 &&
                                    includeESS === true ? (
                                        <TableRowColumn colSpan="1">
                                            {sgipToggle === true &&
                                                annualResults[year].sgipPBI > 0
                                                &&
                                                 projectState === 1 && selectedFinancing > 1
                                                ? `$ ${formattedNumber(annualResults[year].sgipPBI)}`
                                                : '--'}
                                        </TableRowColumn>
                                    ) : null}
                                {selectedFinancing === 3 ? (
                                    <TableRowColumn colSpan="1">
                                        {year <= ((obsTerm + 12) / 12) ?
                                            `$ ${formattedNumber(annualResults[year].annualOBSPayment)}` : '--'}
                                    </TableRowColumn>
                                ) : null}

                                {selectedFinancing === 2
                                    ? (
                                        <TableRowColumn colSpan="1">
                                            {annualResults[year].itc > 0
                                                ? `$ ${formattedNumber(annualResults[year].itc)}`
                                                : '--'}
                                        </TableRowColumn>
                                    ) : null}

                                {selectedFinancing === 4 || (selectedFinancing === 5 && !resiToggle)
                                    ? (
                                        <TableRowColumn colSpan="1">
                                            {annualResults[year].cashITC > 0
                                                ? `$ ${formattedNumber(annualResults[year].cashITC)}`
                                                : '--'}
                                        </TableRowColumn>
                                    ) : null}
                                {selectedFinancing === 3 ? (
                                    <TableRowColumn colSpan="1">
                                        {annualResults[year].obsITC > 0 ?
                                            `$ ${formattedNumber(annualResults[year].obsITC)}` : '--'}
                                    </TableRowColumn>
                                ) : null }
                                {(resiToggle === false && selectedFinancing === 4) ||
                                  (resiToggle === false && selectedFinancing === 2) ||
                              (selectedFinancing === 5) ? (
                                  <TableRowColumn colSpan="1">
                                            {annualResults[year].macrs > 0
                                                ? `$ ${formattedNumber(annualResults[year].macrs)}`
                                                : '--'}
                                        </TableRowColumn>
                                    ) : null }
                                {selectedFinancing === 4 ? (
                                    <TableRowColumn colSpan="1">
                                        {annualResults[year].cashprice > 0
                                            ? `$ ${formattedNumber(annualResults[year].formattedSystemPrice)}`
                                            : '--'}
                                    </TableRowColumn>
                                ) : null}
                                {selectedFinancing === 2 && loanProvider === 'mosaic' ? (
                                    <TableRowColumn colSpan="1">
                                        {annualResults[year].annualHomeLoanPayment > 0
                                            ? `$ ${formattedNumber(annualResults[year].annualHomeLoanPayment)}`
                                            : '--'}
                                    </TableRowColumn>
                                ) : null}
                                {selectedFinancing === 2 && loanProvider === 'custom' ? (
                                    <TableRowColumn colSpan="1">
                                        {annualResults[year].loanPayment > 0
                                            ? `$ ${formattedNumber(annualResults[year].loanPayment)}`
                                            : '--'}
                                    </TableRowColumn>
                                ) : null}
                                {selectedFinancing === 5 ? (
                                    <TableRowColumn colSpan="1">
                                        {year <= (capTerm / 12) ?
                                            `$ ${formattedNumber(annualResults[year].annualCAPPayment)}` : '--'}
                                    </TableRowColumn>
                                ) : null}
                                {selectedFinancing === 4 ? (
                                    <TableRowColumn colSpan="1">
                                        ${formattedNumber(annualResults[year]
                                            .cumulativeCashSavings)}
                                    </TableRowColumn>
                                ) : null}
                                {selectedFinancing === 2 && loanProvider === 'custom' ? (
                                    <TableRowColumn colSpan="1">
                                        ${formattedNumber(annualResults[year]
                                            .cumulativeLoanSavings)}
                                    </TableRowColumn>
                                ) : null}
                                {selectedFinancing === 2 && loanProvider === 'mosaic' ? (
                                    <TableRowColumn colSpan="1">
                                        ${formattedNumber(annualResults[year]
                                            .cumulativeMosaicSavings)}
                                    </TableRowColumn>
                                ) : null}
                                {selectedFinancing === 3 ? (
                                    <TableRowColumn colSpan="1">
                                        ${formattedNumber(annualResults[year].cumulativeOBSSavings)}
                                    </TableRowColumn>
                                ) : null}
                                {selectedFinancing === 5 ? (
                                    <TableRowColumn colSpan="1">
                                        ${formattedNumber(annualResults[year].cumulativeCAPSavings)}
                                    </TableRowColumn>
                                ) : null}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
            <div className="rotate">
                <h1>
                    You are going to save {rotateSavings}. Rotate your device or view on a larger screen to see how with the <em>{rotateOption}</em> cash flow table.
                </h1>
            </div>
        </div>
    );
};
ResultsTable.propTypes = {
    annualResults: PropTypes.object.isRequired,
    selectedFinancing: PropTypes.number.isRequired,
    projectState: PropTypes.number.isRequired,
    sgipToggle: PropTypes.bool.isRequired,
    includeESS: PropTypes.bool.isRequired,
    resiToggle: PropTypes.bool.isRequired,
    obsTerm: PropTypes.number.isRequired,
    capTerm: PropTypes.number.isRequired,
    loanProvider: PropTypes.string.isRequired,
};

export default ResultsTable;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/ResultsTable/ResultsTable.js